// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"594":"about","852":"orders"}[chunkId] + "." + {"594":"b787eaba","852":"fae3d25f"}[chunkId] + ".css";
};